//#region React Imports
import React, {useEffect, useState} from "react";
import {Container} from "react-bootstrap";
import {useLocation, useNavigate} from 'react-router-dom';
//#endregion

//#region Component Imports
import LogoImage from "../../icon/temp/temp-icon-colour.png";
import Navigation from "../../components/Navigation";
import CommonAlert from "../../components/common/Alert";
import ServiceSelection from "../../components/serviceapp/ServiceSelection";
import Footer from "../../components/Footer";
//#endregion

//#region Locale Imports
import {
    API_GET_TEMPLATE,
    API_SERVICE_APP,
    NAVIGATION,
    NAVIGATION_LITURGYAPPNAME,
    ROUTE_SERVICE,
    ROUTE_SERVICEAPP,
    FOOTER,
    FOOTER_CREDITTEXT,
    ROUTE_NEW
} from "../../helpers/GlobalConstants";
//#endregion

//#region Helper Imports
import { GetData } from "../../client";
import {Mapper} from "../../helpers/mappers/Mappers";
import {TemplateContract} from "../../helpers/contracts/TemplateContract";
import {TemplateDto} from "../../helpers/dtos/TemplateDto";
import {GetTemplates} from "../../helpers/services/TemplateWebService";
//#endregion

export default function ServicePage(Props:any){
    const data = Props.Data;
    const navigationAppName = GetData(data, NAVIGATION, NAVIGATION_LITURGYAPPNAME);
    const footerCreditText = GetData(data, FOOTER, FOOTER_CREDITTEXT);
    const location = useLocation();

    const endpointUrl:string = String(process.env.REACT_APP_LITURGY_APP_BACKEND_URL);
    const navigate = useNavigate();
    const [templates, setTemplates] = useState<TemplateContract[]>([]);
    const [alert, setAlert] = useState<boolean>(location.state !== null || false);

    /**
     * Navigates to the service create page with the selected template data
     * @param templateId Template ID to use as a structure for the new service
     */
    const createService = async (templateId: string) => {
        const template = templates.find(data => data.id === templateId);
        if (template) {
            navigate(ROUTE_SERVICEAPP+ROUTE_SERVICE+ROUTE_NEW, { state: template });
        } else {
            setAlert(true);
        }
    }

    useEffect(() => {
        GetTemplates(endpointUrl, API_SERVICE_APP, API_GET_TEMPLATE, setTemplates);
    }, []);

    return (
        <Container fluid>
            <Navigation
                LogoImage={LogoImage}
                BackgroundColour="#4b5648"
                BackgroundCircle="#fffaeb"
                NavigationTextColor="#fffaeb"
                AppName={navigationAppName}/>
            {
                alert
                    ? <CommonAlert
                        severity="error"
                        variant="outlined"
                        alertText={"Template not found."}
                        secondsBeforeClose={0}
                        shouldClose={false} />
                    : null
            }
            <ServiceSelection
                Templates={templates.map((data) => Mapper.map(data, TemplateContract, TemplateDto))}
                AddButtonBehavior={createService}
                CancelButtonBehavior={() => navigate(ROUTE_SERVICEAPP)}/>
            <Footer
                CreditText={footerCreditText}
                BackgroundColor="#303030"
                FooterTextColor="#fffaeb"/>
        </Container>
    );
}
